import 'slick-carousel';
import 'fancybox-core';
import 'fancybox-media';

import fancyBoxModule from '../fancybox';

const $videos = $('.product-videos');

if ($videos.length) {
  $('.product-video-carousel').slick({
    dots: false,
    slidesToShow: 2,
    prevArrow: '<div class="btn-prev"></div>',
    nextArrow: '<div class="btn-next"></div>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  fancyBoxModule.applyFancyBoxVideo($('.product-video-thumbs .video-thumbnail'));
}

function initResizeCarousel() {
  const carousel = $('.product-video-carousel');
  const track = carousel.find('.slick-track');
  const items = carousel.find('.item').length;

  if (window.matchMedia('(min-width: 1200px)').matches) {
    if (items < 5) {
      track.addClass('center');
    } else {
      track.removeClass('center');
    }
  }

  if (window.matchMedia('(min-width: 991px)').matches &&
      window.matchMedia('(max-width: 1199px)').matches) {
    if (items < 4) {
      track.addClass('center');
    } else {
      track.removeClass('center');
    }
  }

  if (window.matchMedia('(min-width: 767px)').matches &&
      window.matchMedia('(max-width: 991px)').matches) {
    if (items < 2) {
      track.addClass('center');
    } else {
      track.removeClass('center');
    }
  }

  if (window.matchMedia('(max-width: 767px)').matches) {
    track.removeClass('center');
  }
}

$(window).resize(() => {
  initResizeCarousel();
});
initResizeCarousel();
